import appleLogo from '../integrations/logos/apple.svg';
import linuxLogo from '../integrations/logos/linux.svg';
import serverLogo from '../integrations/logos/server.svg';
import windowsLogo from '../integrations/logos/windows.svg';

export type RelayPlatformMeta = { label: string; logo: string };

const KNOWN: Record<string, RelayPlatformMeta> = {
  win32: { label: 'Windows', logo: windowsLogo },
  linux: { label: 'Linux', logo: linuxLogo },
  darwin: { label: 'macOS', logo: appleLogo },
};

export function relayPlatformMeta(platform: string | null): RelayPlatformMeta {
  return (platform !== null ? KNOWN[platform] : undefined) ?? { label: 'Server', logo: serverLogo };
}
